const BotActionsEnum = {
  Start: 'Start',
  End: 'End',
  Resume: 'Resume',
  Pause: 'Pause',
  PrintScreen: 'PrintScreen',
};

export const BotActions = Object.freeze(BotActionsEnum);
